/**
 * @description 根组件
 * @date 2025-07-21 16:25:01
 * @author jackdan
 */
import React, { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ConfigProvider } from 'antd';

import { routes } from './router';
import { CityCacheProvider } from './components/CityCache';

function App() {
  return (
    <ConfigProvider theme={{
      token: {},
      components: {
        Spin: {
          colorPrimary: "rgba(54, 178, 97, 1)"
        }
      }
    }}>
      <CityCacheProvider>
        <RouterProvider router={routes} />
      </CityCacheProvider>
    </ConfigProvider>
  );
}

export default App;
